import { render, staticRenderFns } from "./MantenedorTelcoPantalla.vue?vue&type=template&id=0934b296&"
import script from "./MantenedorTelcoPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTelcoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports